import Color from 'components/color';

export default {
  background() {
    if (this.props.template === 'background') {
      if (this.props.background_image) {
        return this.background_image(this.props.background_image);
      }
      return {};
    }
    if (this.props.background_color) {
      return this.background_color(this.props.background_color);
    }
    return {};
  },

  background_color(color) {
    if (color) {
      return { backgroundColor: new Color(color).toRgba() };
    }
    return {};
  },

  background_image(url) {
    if (url) {
      return { backgroundImage: `url("${url}")` };
    }
    return {};
  },

  borderColor(color) {
    if (color) {
      return { borderColor: new Color(color).toRgba() };
    }
    return {};
  },

  color(color) {
    if (color) {
      return { color: new Color(color).toRgba() };
    }
    return {};
  },

  primary_text_color() {
    return this.color(this.props.primary_text_color);
  },

  primaryBorderColor() {
    return this.borderColor(this.props.primary_text_color);
  },

  secondary_text_color() {
    return this.color(this.props.secondary_text_color);
  },

  hrBackgroundColor() {
    return this.background_color(this.props.secondary_text_color);
  },

  button() {
    if (this.props.button_color && this.props.button_text_color) {
      return {
        background: new Color(this.props.button_color).toRgba(),
        color: new Color(this.props.button_text_color).toRgba(),
      };
    }
    return {};
  },

  borderButton() {
    if (this.props.button_color) {
      return {
        color: new Color(this.props.button_color).toRgba(),
        borderColor: new Color(this.props.button_color).toRgba(),
      };
    }
    return {};
  },

  /**
   * Shadow distance takes a max integer of 100, min of 0
   * the strength should be the inverse of the value divided by 100
   * We also need to normalize any color input, so that can happen here too.
   * @returns {{boxShadow: string}}
   */
  shadow() {
    if (this.props.shadow_distance) {
      const distance = this.props.shadow_distance;
      const strength = (100 - distance) / 100.0;
      const color = new Color(this.props.shadow_color);
      color.a = strength;
      return { boxShadow: `0 0 ${distance}px ${color.toRgba()}` };
    }
    return {};
  },

  /**
   * We should probably do a more descriptive name here, something relating to hiding.
   * @returns {*}
   */
  has_status_page() {
    if (this.props.has_status_page === 'no') {
      return { display: 'none' };
    }
    return {};
  },

  /**
   * This is a simple multi object merge.  Takes an arbitrary number of objects
   * @returns {Object} single object with all the attributes of the inputed
   */
  mergeStyles() {
    const newObj = {};
    for (let i = 0; i < arguments.length; i++) {
      for (const attrname in arguments[i]) {
        newObj[attrname] = arguments[i][attrname];
      }
    }
    return newObj;
  },

  support_email_address() {
    if (this.props.support_email_address) {
      if (this.props.support_email_address.indexOf('@') != -1) {
        return `mailto:${this.props.support_email_address}`;
      }

      return this.props.support_email_address;
    }
    return 'javascript:alert("Looks like you didn\'t add a Support URL on the previous step.")';
  },

  href(url) {
    if (url) {
      // We need to add http to urls so the links work and aren't relative
      return url.toLowerCase().indexOf('http') < 0 ? `http://${url}` : url;
    }
    return '#';
  },
};
